import { c as _c } from "react/compiler-runtime";
import { sendGA4Event } from "../../../global-account/utils/analytics.js";
import { useAccountWallet } from "./useAccountWallet.js";
/**
 * Analytics hook that provides sendAnalyticsEvent function
 * Automatically includes user address from useAccountWallet
 */
export function useAnalytics() {
  const $ = _c(4);
  const {
    address
  } = useAccountWallet();
  let t0;
  if ($[0] !== address) {
    t0 = (eventName, parameters) => {
      const eventData = {
        user_address: address,
        ...parameters
      };
      sendGA4Event(eventName, eventData);
    };
    $[0] = address;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const sendAnalyticsEvent = t0;
  let t1;
  if ($[2] !== sendAnalyticsEvent) {
    t1 = {
      sendAnalyticsEvent
    };
    $[2] = sendAnalyticsEvent;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}